import { render } from "./reset-password-2.vue?vue&type=template&id=6bc45ad1"
import script from "./reset-password-2.vue?vue&type=script&lang=js"
export * from "./reset-password-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__